export default "__VITE_ASSET__DXLVn9yg__"